/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * When the quest resets. The user stats for this quest will be reset.
 * @export
 * @enum {string}
 */
export enum QuestReset {
    MONTHLY = 'MONTHLY',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    NONE = 'NONE'
}

export function QuestResetFromJSON(json: any): QuestReset {
    return QuestResetFromJSONTyped(json, false);
}

export function QuestResetFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestReset {
    return json as QuestReset;
}

export function QuestResetToJSON(value?: QuestReset | null): any {
    return value as any;
}

